import * as tslib_1 from "tslib";
import { RobotHostingType, RobotType, } from '@models';
import { RobotCredentialsControl, RobotFormControl, RobotModalBaseComponent, } from '@pages/robots/modal/robot-base.modal';
import { addToObjectIf } from '@utils/object.utils';
var FloatingRobotModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FloatingRobotModalComponent, _super);
    function FloatingRobotModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._getFormValueToCreateAnother = function (robot) {
            var _a, _b, _c;
            return (tslib_1.__assign((_a = {}, _a[RobotFormControl.hostingType] = robot.hostingType, _a[RobotFormControl.type] = [_this._robotTypeToDropdownEntry(robot.type)], _a[RobotFormControl.isExternalLicense] = !!robot.isExternalLicense, _a), addToObjectIf(robot.type !== RobotType.Attended, (_b = {},
                _b[RobotFormControl.robotCredentials] = (_c = {},
                    _c[RobotCredentialsControl.credentialStore] = [_this._credentialStoreToDropdownEntry(_this.selectedCredentialStore)],
                    _c),
                _b))));
        };
        return _this;
    }
    Object.defineProperty(FloatingRobotModalComponent.prototype, "hostingType", {
        get: function () {
            return RobotHostingType.Floating;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FloatingRobotModalComponent.prototype, "formTitle", {
        get: function () {
            return this._translateService.instant('robot_modal_form_floating_title');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FloatingRobotModalComponent.prototype, "formDescription", {
        get: function () {
            return this._translateService.instant('robot_modal_form_floating_info_text');
        },
        enumerable: true,
        configurable: true
    });
    return FloatingRobotModalComponent;
}(RobotModalBaseComponent));
export { FloatingRobotModalComponent };
